export enum ArtifactType  {
    None = 0,
    Image = 1,
    Video = 2,

}